import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { NON_TRADE_LOAD_DATA } from '@/store/types'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'

export const nonTradeAjaxMixin = {
  data() {
    return {
    }
  },
  created() {
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  methods: {
    async performNonTradeSearch() {
      const apiUrl = this.$store.state.nonTrade.menu.performSearch
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationNonTrade
          const paramMap = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.nonTradeFilterForm)
          if (messageFilters.tranDate !== null && messageFilters.tranDate !== '') {
            messageFilters.tranDate = formatDisplayDateTime2(removeTime(messageFilters.tranDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, paramMap), messageFilters, this.paginationNonTrade.sortBy, this.paginationNonTrade.sortDesc))
          const { data } = result.data
          if (data) {
            this.totalItemsNonTrade = result.data.totalElements
            this.itemsNonTrade = []
            data.map((result) => {
              const resultList = {
                branch: result.branch,
                type: result.type,
                documentNo: result.docNo,
                addrTo: result.addressedTo,
                fund: result.fund,
                suffix: result.suffix,
                tranDate: this.formatDate(result.tranDate),
                curr: result.curr,
                netAmt: formatPrice(result.netAmount),
                local: formatPrice(result.locAmt),
                acctNo: '',
                postNow: result.postNow,
                osBalance: formatPrice(result.osBalance),
                zeroBal: result.zeroBal,
                bankTranDate: result.bankTranDate,
                chequePrtd: result.chequePrtd,
                bankListPrtd: result.bankListPrtd,
                bankPayInPrtd: result.bankPayInPrtd,
                docPrtd: result.docPrtd,
                brnDocListPrtd: result.brnDocListPrtd,
                bchMch: result.bchMch
              }
              this.itemsNonTrade.push(resultList)
            })
          } else {
            this.itemsNonTrade = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    async performNonTradeSave() {
      const apiURI = this.$store.state.nonTrade.menu.performAction
      if (apiURI) {
        try {
          let messageFilters = clone(this.nonTradeForm)
          if (messageFilters.transactionDate !== '') {
            messageFilters.transactionDate = formatDisplayDate(messageFilters.transactionDate)
          }
          const result = await this.$http.post(apiURI, messageFilters)
          const { data } = result
          if (data) {
            const nonTradeInfo = {
              tranMode: 'R',
              branch: this.nonTradeForm.branch,
              accountNo: this.nonTradeForm.accountNo,
              type: this.nonTradeForm.transactionType,
              documentNo: data.resultMap.documentNo,
              fund: this.nonTradeForm.fund,
              suffix: this.nonTradeForm.accountNoSuffix,
              currency: this.nonTradeForm.netAmountCurr,
              amount: this.nonTradeForm.amount,
              gstAE: this.nonTradeForm.gstAmountAE,
              gst: this.nonTradeForm.gstAmount,
              netAmt: this.nonTradeForm.netAmount,
              tranDate: this.nonTradeForm.transactionDate,
              actionName: this.nonTradeForm.actionName,
              printDoc: this.nonTradeForm.printDocument,
              currencyRate: this.nonTradeForm.amountCurrRate,
              gstStatus: this.nonTradeForm.gstStatus,
              gstRate: this.nonTradeForm.gstRate,
              netLocAmt: Math.abs(data.resultMap.netLocAmount)
            }
            this.$store.commit(NON_TRADE_LOAD_DATA, nonTradeInfo)
            this.nonTradeForm.documentNo = data.resultMap.documentNo
            this.notify(data)
            // AR: OS-660 Unlock Record upon exit 29-Jan-2021
            let recKey = this.nonTradeForm.transactionType + '|' +
                        this.nonTradeForm.branch + '|' +
                        this.nonTradeForm.accountNo + '|' +
                        this.nonTradeForm.documentNo + '|' +
                        this.nonTradeForm.fund + '|' +
                        this.nonTradeForm.accountNoSuffix
            this.unlockRecord(recKey, 'ACT')
            if (this.nonTradeForm.actionName === 'CREATE_SAVE_REVIEW' || this.nonTradeForm.actionName === 'UPDATE_SAVE_REVIEW') {
              this.$router.push({ name: 'nonTrade' })
            } else {
              this.$router.push({ name: 'glNonTrade' })
            }
            this.doExit()
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async performNonTradeReview() {
      const apiURI = this.$store.state.nonTrade.menu.performAction
      if (apiURI) {
        try {
          this.nonTradeForm.actionName = 'NON_TRADE_REVIEW'
          this.nonTradeForm.branch = this.nonTradeData.branch
          this.nonTradeForm.accountNo = ''
          this.nonTradeForm.transactionType = this.nonTradeData.type
          this.nonTradeForm.documentNo = this.nonTradeData.documentNo
          this.nonTradeForm.fund = this.nonTradeData.fund
          this.nonTradeForm.accountNoSuffix = this.nonTradeData.suffix
          const response = await this.$http.post(apiURI, this.nonTradeForm)
          const { data } = response.data
          if (data) {
            this.$set(this, 'nonTradeForm', data.accounts)
            this.nonTradeForm.amount = formatPrice(data.accounts.amount)
            this.nonTradeForm.gstAmount = formatPrice(data.accounts.gstAmount)
            this.nonTradeForm.netAmount = formatPrice(data.accounts.netAmount)
            this.nonTradeForm.bankAmount = formatPrice(data.accounts.bankAmount)
            this.nonTradeForm.bankCharges = formatPrice(data.accounts.bankCharges)
            this.nonTradeForm.bankTotalLocal = formatPrice(data.accounts.bankTotalLocal)
            this.nonTradeForm.docAE = data.accounts.docAE === 'true'
            this.nonTradeForm.gstAmountAE = data.accounts.gstAmountAE === 'true'
            this.nonTradeForm.bankAmountAE = data.accounts.bankAmountAE === 'true'
            this.nonTradeForm.bankTotalLocalAE = data.accounts.bankTotalLocalAE === 'true'
            this.nonTradeForm.prtCheque = data.accounts.prtCheque === 'true'
            this.nonTradeForm.fromBank = data.accounts.bankNo
            this.nonTradeForm.transactionDate = data.accounts.transactionDate
            if (data.accounts.bankCharges === null || data.accounts.bankCharges === 'NaN') {
              this.nonTradeForm.bankCharges = '0.00'
            }
            if (data.accounts.gstRate === null || data.accounts.gstRate === 'NaN') {
              this.nonTradeForm.gstRate = '0.00'
            }
            if (data.accounts.netAmount === null || data.accounts.netAmount === 'NaN') {
              this.nonTradeForm.netAmount = '0.00'
            }
            if (data.accounts.bankAmount !== '' && data.accounts.bankAmount !== null) {
              this.nonTradeForm.bankTotalAmount = formatPrice(Number(removeFormatNumber(data.accounts.bankAmount)) + Number(removeFormatNumber(data.accounts.bankCharges)))
            }
            this.nonTradeForm.policyNo = ''
            if (data.accounts.polNo !== null && data.accounts.polNo !== '') {
              this.nonTradeForm.policyNo = data.accounts.polNo + '-' + data.accounts.renCnt + '-' + data.accounts.endtCnt
            }
            if (data.accounts.fund === null) {
              this.nonTradeForm.oldFund = ''
            } else {
              this.nonTradeForm.oldFund = data.accounts.fund
            }
            this.nonTradeForm.addressTo = 'E'
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doChkBatch(params) {
      this.matchBatchProcess = false
      const apiUrl = this.$store.state.accounts.menu.matchBatchProcess
      if (apiUrl) {
        try {
          const requestParams = {
            branch: params.branch,
            acctNo: params.acctNo,
            tranType: params.type,
            docNo: params.documentNo,
            fund: params.fund,
            acctNoSfx: params.suffix
          }
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.matchBatchProcess = true
            this.matchCreatedProgId = data.createdProgId
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async doChkGLTran(params) {
      this.glTranFound = false
      const apiUrl = this.$store.state.accounts.menu.glTranBchNo
      if (apiUrl) {
        try {
          const requestParams = {
            branch: params.branch,
            tranType: params.type,
            docNo: params.documentNo,
            acctNo: params.acctNo,
            acctNoSfx: params.suffix
          }
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.glTranFound = true
            this.glTranBchNo = data.bchNo
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async fetchDelData(infor) {
      const apiUrl = this.$store.state.nonTrade.menu.deleteAccount
      try {
        const requestParams = infor
        if (apiUrl) {
          this.$http.post(apiUrl, requestParams).then(result => {
            const data = result.data
            this.notify(data)
            this.doClearFilters()
          }).catch(err => {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          })
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.notify(data)
        }
      }
    },
    async fetchBranch() {
      this.branches = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchBranch
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.branches.push(data)
              })
            }
          }
        })
      }
    },
    async fetchBank() {
      this.banks = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchBank
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.banks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAcctNoSfx() {
      this.acctnosuffixes = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchAcctNoSfx
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.acctnosuffixes.push(data)
              })
            }
          }
        })
      }
    },
    async fetchGstStatus() {
      this.gstStatuses = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchGstStatus
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.gstStatuses.push(data)
              })
            }
          }
        })
      }
    },
    async fetchAmountCurrency() {
      this.amountcurrencies = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchAmountCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.amountcurrencies.push(data)
              })
            }
          }
        })
      }
    },
    async fetchCurrency() {
      this.currencies = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.currencies.push(data)
              })
            }
          }
        })
      }
    },
    async fetchDepartment() {
      this.departments = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchDepartment
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.departments.push(data)
              })
            }
          }
        })
      }
    },
    async fetchPayerBank() {
      this.payerbanks = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchPayerBank
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.payerbanks.push(data)
              })
            }
          }
        })
      }
    },
    async fetchPaymentMethod() {
      this.paymentmethods = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchPaymentMethod
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.paymentmethods.push(data)
              })
            }
          }
        })
      }
    },
    async fetchFund() {
      this.funds = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchFund
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.funds.push(data)
              })
            }
          }
        })
      }
    },
    async fetchBranchWBranchUserId() {
      this.branches = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchBranchWBranchUserId
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.branches.push(data)
              })
            }
          }
        })
      }
    },
    checkFiltersNullValue() {
      return Object.keys(this.nonTradeFilterForm)
        .every(key => this.nonTradeFilterForm[key] === null ||
          this.nonTradeFilterForm[key] === '' ||
          this.nonTradeFilterForm[key] === undefined
        )
    },
    doExportFilters() {
      const checknull = this.checkFiltersNullValue()
      if (checknull) {
        this.exportList.promptFilterWarning = true
      } else {
        this.exportList.promptFilterWarning = false
        this.doExportList()
      }
    },
    async doExportList() {
      let columns = []
      let columnsTitle = []
      this.nonTradeColumns.map(t => {
        columnsTitle.push(t.text)
        columns.push(t.value)
      })
      const apiUrl = this.$store.state.nonTrade.menu.exportAcctTypeFilteredList
      if (apiUrl) {
        try {
          let massageForm = clone(this.nonTradeFilterForm)
          massageForm.acctType = 'Non-Trade'
          massageForm.columns = columns.join(',')
          massageForm.columnsTitle = columnsTitle.join(',')
          await this.$http.post(apiUrl, massageForm)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mixins: [
    MessageMixin,
    recordLockMixin
  ]
}
